import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HeadTitle = styled(Typography)`
  text-align: center;
  width: 100%;
`;

export { HeadTitle };
